import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Grid, Col, Row, Form, FormGroup, FormControl,
  ControlLabel, Button
} from 'react-bootstrap'
import Radio from '../../components/CustomRadio/CustomRadio'
import { constants } from '../../redux/lessons/actions'
import { canAnswerLesson } from '../../redux/lessons/reducer'
import { commonConstants } from '../../redux/common/actions'
import ClipLoader from 'react-spinners/ClipLoader'
import YoutubeEmbed from 'components/YoutubeEmbed'
import { useResponsive } from 'react-hooks-responsive'
import Card from "components/Card/Card.jsx";
import { getFormattedUser } from "../../services/auth";
import { default as Plotly } from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
import { apiV2 } from 'services/api'
import moment from 'moment'
import LessonStats from './LessonStats'

const { UPDATE_LESSON_FORM_FIELD,
  FETCH_LESSON, UPDATE_LESSON_RESPONSE, FETCH_LESSON_RESPONSE } = constants
const { REQUEST } = commonConstants

const LessonDetail = ({ match, history }) => {
  const { loading, error, success, ...form } = useSelector(state => state.lessons)
  // Answers stay locked until this module's saved answers have loaded.
  const canAnswer = useSelector(state => canAnswerLesson(state.lessons, match.params.id))
  const {
    id, title, description, updatedAt, videoUrl, documentUrl, questions, lessonResponse
  } = form

  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(window.location.search)
  const readOnlyMode = searchParams.has('readOnly') && searchParams.get('readOnly') === 'true'

  // retrieve user
  const [callTakerId, setCallTakerId] = useState(null)
  const [hasAdmin, setHasAdmin] = useState(false)
  const [, setAllResponses] = useState([])
  useEffect(() => {
    async function getAuth() {
      const user = await getFormattedUser()
      const hasAdmin = user && user.roles && (user.roles.includes('SuperAdmin') || user.roles.includes('HrAdmin'))
      setHasAdmin(hasAdmin)
      setCallTakerId(user.id)
      if(hasAdmin) {
        createPlotlyComponent(Plotly)
        getLessonResponses()
      }
    }
    getAuth().then()
  }, [])


  const getLessonResponses = () => {
    if(hasAdmin && match.params.id) {
      apiV2.lessonResponses.getAll(match.params.id)
        .then((res) => {
          setAllResponses(res)
        })
    }
  }

  // initial page fetch
  useEffect(() => {
    if (match.params.id) {
      dispatch({ type: FETCH_LESSON + REQUEST, payload: { id: match.params.id } })
      dispatch({ type: FETCH_LESSON_RESPONSE + REQUEST, payload: { lesson: match.params.id, call_taker_id: callTakerId } })
    }
    return () => { }
  }, [callTakerId, match.params.id, dispatch])


//  const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

//  const submitRoute = match.params.id > 0 ? UPDATE_LESSON : SUBMIT_LESSON_FORM

  const breakpoints = { xs: 0, sm: 425, md: 1024 }
  const { size } = useResponsive(breakpoints)
  const radioStyle = size === 'xs' ? { transform: 'scale(3)', margin: 16, marginLeft: 30 } : {}

  const updateQuestionResponse = (question_index, index) => {
    dispatch({ type: UPDATE_LESSON_RESPONSE + REQUEST, payload: { id, call_taker_id: callTakerId, question_index, index } })
  }

  // handle submit
  const [historyNavigation, setHistoryNavigation] = useState({ enabled: false, id: null })
  useEffect(() => {
    if (historyNavigation.enabled) {
      history.push(`/admin/module/${historyNavigation.id}/summary/`)
    }
    return () => { }
  }, [historyNavigation.enabled])

  var questionsLeftCount = questions.length
  if (lessonResponse) {
    questionsLeftCount = questions.length - lessonResponse.responses.filter(x => x != null).length
  }

  const submitLesson = () => {
    if(questionsLeftCount > 0 || !canAnswer || !lessonResponse.id) {
      return
    }

    apiV2.lessonResponses.complete(lessonResponse.id, true)
      .then((res) => {
        setHistoryNavigation({ enabled: true, id: id })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  if (loading.source === FETCH_LESSON) {
    return (
      <div className='main-content' style={{ textAlign: 'center' }}>
        <ClipLoader loading size={50} color="grey" />
      </div>
    )
  }

  const renderQuestions = () => {
    return questions.map((prop, index) => {
      return (
        <Card
          key={'question-card' + index}
          content={
            <>
            <Row>
              <Grid fluid>
                <Row>
                  <Col xs={12} sm={12}>
                    <FormGroup>
                      <ControlLabel>
                        Question #{index + 1}
                      </ControlLabel>
                      <div><b>{prop.question}</b></div>
                    </FormGroup>
                  </Col>
                </Row>
              </Grid>
              {renderAnswers(index, prop.answers)}
            </Row>
            </>
          }
        />
      )
    })
  }

  const renderAnswers = (question_index, answers) => {
    return answers.map((prop, index) => {
      let responseList = []
      if(lessonResponse.responses){
        responseList = lessonResponse.responses
      }

      return (
        <Row
          style={{ marginLeft: 20 }}
          key={'answer-row' + index}
        >
          <Col xs={12} sm={12}>
            <Form>
              {/* <ControlLabel>
                <b>{alphabet[index]}</b>
              </ControlLabel> */}
              <span>
                <Radio
                  id={'answer-' + index}
                  type={'radio'}
                  option={responseList.length > question_index ? (lessonResponse.responses[question_index] === index) : false}
                  name="answer"
                  onChange={() => updateQuestionResponse(question_index, index)}
                  disabled={!canAnswer}
                  checked={responseList.length > question_index ? (lessonResponse.responses[question_index] === index) : false}
                  label={prop.answer}
                  style={radioStyle}
                />
                {/* {prop} */}
              </span>
            </Form>
          </Col>
        </Row>
      )
    })
  }

  const parseUrl = (url) => {
    if(url.includes('youtube')) {
      return url.substring(url.indexOf('v=') + 2)
    } else {
      return url
    }
  }

  const moduleNumber = id

  return (
    <div className='main-content'>
      <Grid fluid>
        <h3 style={{marginBottom: 20}}><b>Module #{moduleNumber}:</b> {title}</h3>
        <h6><b>Date: </b>{moment(updatedAt).format('MMMM DD, YYYY')}</h6>
        <div style={{marginTop: 10}}>{description}</div>

        <Form>
          <Row>
            {/* <Col xs={12} sm={12}>
              <FormGroup>
                <ControlLabel>Module #{moduleNumber}</ControlLabel>
                <FormControl
                  type='text'
                  id='title'
                  name='title'
                  value={title ? title : ''}
                  disabled={readOnlyMode}
                  onChange={event => handleChange(dispatch, event)}
                />
              </FormGroup>
            </Col> */}
            <Col xs={12} sm={12} style={{ marginBottom: 20 }}>
              {videoUrl &&
                <>
                  <h5>Module Video</h5>
                  <YoutubeEmbed embedId={parseUrl(videoUrl)} />
                  <FormGroup>
                    {/* <ControlLabel>Video Url</ControlLabel> */}
                    <FormControl
                      type='text'
                      id='videoUrl'
                      name='videoUrl'
                      value={videoUrl ? videoUrl : ''}
                      disabled={readOnlyMode}
                      onChange={event => handleChange(dispatch, event)}
                    />
                  </FormGroup>
                </>
              }
              {documentUrl &&
                <h3>
                  <a href={documentUrl} target="_blank" rel="noopener noreferrer">View Module Questionnarie</a>
                </h3>
              }
            </Col>
          </Row>
        </Form>

        <h5>Module Questions</h5>

        {renderQuestions()}

        <Row>
          <LessonStats hasAdmin={hasAdmin} id={match.params.id}/>
        </Row>

        <Row style={{marginTop: 20}}>
          <Col xs={12} sm={6}>
            <Button
              style={{ marginRight: '15px' }}
              bsStyle='warning'
              bsSize="lg"
              onClick={() => { window.location.href = "/admin/professional-development" }}
            >
              Back
            </Button>
            <Button
              style={{ marginRight: '15px' }}
              bsStyle='primary'
              bsSize="lg"
              disabled={questionsLeftCount > 0 || !canAnswer}
              onClick={() => submitLesson()}
            >
              Submit
            </Button>
            {questionsLeftCount > 0 &&
              <div style={{marginTop: 10}}>You must answer all questions before submitting the module.</div>
            }
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

function handleChange(dispatch, event, formField) {
  let field = null
  let value = null
  if (formField === 'dateVerified') {
    field = formField
    value = event._d
  } else if (event.target) {
    field = event.target.name
    value = event.target.value
    value = value === "true" ? true : value
    value = value === "false" ? false : value
  } else { // select form items
    field = formField
    value = event
  }
  return dispatch({ type: UPDATE_LESSON_FORM_FIELD, field, value })
}

export default LessonDetail